
export default function Hero() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 50%, rgba(255, 255, 255, 0.7) 70%, rgba(255, 255, 255, 0.3) 100%), url('https://public.readdy.ai/ai/img_res/beea983037ede65ce6e40697ea00594e.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="max-w-2xl">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Secure Your Digital Life with Our VPN
          </h2>
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            SALONASPED d.o.o. delivers cutting-edge VPN technology to protect your online privacy and security. Experience fast, reliable, and encrypted connections wherever you go.
          </p>
          <div className="flex gap-4">
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg"
            >
              Get Started
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('features');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap border-2 border-teal-600"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
